import "react-quill/dist/quill.snow.css"
import "./gap-styling-animations.css"

import { Avatar, Button, Box } from "@mui/material"
import { CREATED_BY, CREATED_DATE, DISABLED, ID, NAME, getProp, titleLine } from "../CommonColumns"
import { DateTimeWidget } from "../CustomWidgets"
import { DataProvider, ListComponent } from "../../GenericList"
// RaffleTable.js
import { useEffect, useState } from "react"

import CustomObjectFieldTabs from "./CustomObjectFieldTabs"
import TicketDesignPopup from "./TicketDesignPopup"
// import { Button } from "@mui/material"
// import { ImageWidget } from "./components/CustomWidgets"
// import LoadingScreen from "react-loading-screen"
// import MUIDataTable from "mui-datatables"
// import { db } from "../firebase"
// import { useNavigate } from "react-router-dom"
import { DateTime } from "luxon"
import { Timestamp } from "firebase/firestore"
import { auth } from "../../firebase"
import { convertToMeasure } from "../../utils"
import { useAppConfiguration } from "../AppConfigurationService"
import { useNavigate } from "react-router-dom"
import React from "react"
import { Loading } from "react-ui-components/components/LoadingService"
import { PopupService } from "react-ui-components/components/PopupService"
import { GOAL_RAFFLE_TYPE } from "react-ui-components/components/models/IRaffleGoal"
import { raffleSchema } from "react-ui-components/components/raffle/raffleSchema"
import { raffleUISchema } from "react-ui-components/components/raffle/raffleUISchema"
import {
  normalizeRaffleMediaItems,
} from "react-ui-components/components/raffle/raffleMediaUtils"
import htmr from "htmr"
import { GapStylingService } from "./GapStylingService"
import { RootComponent } from "./RootComponent"
import { GapStylingComponent,
  GapStylingConfig,
  defaultConfig
} from "./gap-styling";
import {
  ALLOWED_ZIP_HELP_TEXT,
  normalizeRaffleForForm,
  prepareRaffleForSave,
} from "./raffleFormUtils"
import {
  assertRaffleMediaItemsSafeForPersistence,
  stripTemporaryRaffleMediaFields,
} from "./raffleMediaPersistenceGuards"

// import { collection, getDocs } from "firebase/firestore"

const ticketDesign = (showEdit: any) => {
  return {
    name: "ticketDesign",
    type: "object",
    label: "Ticket Design",

    properties: {
      backgroundColor: { type: "string", title: "Background Color" },
      color: { type: "string", title: "Color" },
      height: { type: "number", title: "Height" },
      justifyContent: { type: "string", title: "Justify Content" },
      margin: { type: "number", title: "Margin" },
      padding: { type: "number", title: "Padding" },
      displayAsImage: { type: "boolean", title: "Display As Image", default: false },
      showBackgroundImage: { type: "boolean", title: "Show Background Image", default: true },
      showCode: { type: "boolean", title: "Show Code", default: true },
      showDate: { type: "boolean", title: "Show Date", default: true },
      showImageOverlay: { type: "boolean", title: "Show Image Overlay", default: true },
      showRaffle: { type: "boolean", title: "Show Raffle", default: true },
      showShadow: { type: "boolean", title: "Show Shadow", default: true },
      showText: { type: "boolean", title: "Show Text", default: true },
      showTicketStub: { type: "boolean", title: "Show Ticket Stub", default: true },
      textColor: { type: "string", title: "Text Color" },
      width: { type: "number", title: "Width" },
    },
    options: {
      customBodyRender: (
        value: {
          backgroundColor: any
          textColor: any
          color: any
          height: any
          width: any
          padding: any
          margin: any
          justifyContent: any
          image?: string
        },
        tableMeta: { rowData: any[] },
        updateValue: (value: any) => void,
      ) => {
        const raffleId = tableMeta?.rowData?.[0]
        value = value || {
          textColor: "#000",
          color: "#000",
          justifyContent: "center",
          backgroundColor: "#FFF",
          margin: 5,
          image: "",
          height: 120,
          width: 180,
          padding: 5,
        }
        return (
          <div className="flex flex-col flex-wrap overflow-auto w-full h-40 overflow-hidden">
            <div
              onClick={(e) => e.stopPropagation()}
              className="flex flex-col overflow-hidden"
              style={{
                backgroundColor: value.backgroundColor,
                color: value.textColor || value.color,
                height: value.height,
                width: value.width,
                padding: `calc(${convertToMeasure(value.padding)} + 5px)`,
                margin: value.margin,
                justifyContent: value.justifyContent,

                borderWidth: 1,
                borderColor: "#DDD",
                borderRadius: 20,
              }}
            >
              <p>
                <b>TEST 1:</b> testing 1234
              </p>
              <p>
                <b>TEST 2:</b> testing 1234
              </p>
              <p>
                <b>TEST 3:</b> testing 1234
              </p>
            </div>
            {!showEdit || !raffleId ? null : (
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  PopupService.setPopup(
                    <TicketDesignPopup
                      raffleId={raffleId}
                      design={value}
                      onSaved={(nextDesign) => updateValue(nextDesign)}
                    />,
                    "Edit Ticket Design",
                    { width: "90vw" },
                  )
                }}
              >
                Edit
              </button>
            )}
          </div>
        )
      },
    },
  }
}

/*
  createdBy(string)
  createdDate(number)
  description(string)
  disabled(boolean)
  height(number)
  id(string)
  lastTicketIndex(number)
  name(string)
  order(number)
  points(number)
  province(string)
  raffleDate(number)
  raffleImages(array)-(string)
  raffleLocation(map)
  
  subtitle(string)
  termsText(string)
  ticketDesign(null)
  title(string)
  type(string)
  value(number)
  */
/*
        disabled: types.optional(types.boolean, false),
        name: types.optional(types.string, ""),
        city: types.optional(types.string, "*"),
        country: types.optional(types.string, "*"),
        province: types.optional(types.string, "*"),
        county: types.optional(types.string, "*"),
        street: types.optional(types.string, "*"),
        info: types.optional(types.string, ""),
        image: types.optional(types.string, ""),
        phone: types.optional(types.string, ""),
        houseNumber: types.optional(types.string, ""),
        postcode: types.optional(types.string, ""),
  */

const Raffles = () => {
  const [data, setData] = useState<any>(null)
  const [gapStylingConfig, setGapStylingConfig] = useState<GapStylingConfig>(defaultConfig)
  const { configuration } = useAppConfiguration()
  const availableRaffleTypes = React.useMemo(() => {
    const configuredTypes = Array.isArray(configuration?.raffleTypes)
      ? configuration.raffleTypes
      : []

    return configuredTypes.includes(GOAL_RAFFLE_TYPE)
      ? configuredTypes
      : [...configuredTypes, GOAL_RAFFLE_TYPE]
  }, [configuration?.raffleTypes])

  // Load gap styling configuration from Firebase
  const loadGapStylingConfig = async () => {
    try {
      const savedConfig = await GapStylingService.loadConfig()
      if (savedConfig) {
        setGapStylingConfig({ ...defaultConfig, ...savedConfig })
      }
    } catch (error) {
      console.error("Error loading gap styling configuration:", error)
    }
  }

  // Save gap styling configuration to Firebase
  const saveGapStylingConfig = async (config: GapStylingConfig) => {
    await GapStylingService.saveConfig(config)
  }

  // Load gap styling configuration on component mount
  useEffect(() => {
    loadGapStylingConfig()
  }, [])

  useEffect(() => {
    setData({
      widgets: {
        DateTimeWidget,
      },
      onRowClick: (
        list: { [x: string]: any },
        navigate: (arg0: string, arg1: { state: any }) => void,
      ) => {
        return (_rowData: any, rowMeta: { dataIndex: string | number }) => {
          const state = list[rowMeta.dataIndex]
          const id = state.id
          navigate(`/raffles/${id}`, { state })
        }
      },
      getListLocation(id: any) {
        return ["raffles"]
      },

      EDIT_TITLE: "Edit Raffle",
      ADD_TITLE: "Add Raffle",
      LOADING_MESSAGE: "Loading raffles...",
      TITLE: "Raffles",
      IMAGES_BUCKET: "rafflesImages",

      columnsProperties: [
        ID,
        CREATED_DATE,
        CREATED_BY,
        DISABLED,
        {
          hidden: false,
          type: "string",
          required: true,
          name: "type",
          label: "Type",
          title: "Type Title",
          enum: availableRaffleTypes,
        },
        getProp("title", "string"),
        getProp("subtitle", "string"),
        getProp(
          {
            name: "description",
            options: {
              customBodyRender: (value: string) => {
                return (
                  <div className="max-h-[120px] overflow-auto">{value ? htmr(value) : value}</div>
                )
              },
            },
          },
          "string",
        ),
        getProp(
          {
            name: "termsText",
            options: {
              customBodyRender: (value: string) => {
                return (
                  <div className="max-h-[120px] overflow-auto">{value ? htmr(value) : value}</div>
                )
              },
            },
          },
          "string",
        ),
        getProp("termsUrl", "string"),
        getProp("videoUrl", "string"),
        getProp("youtubeUrl", "string"),
        getProp("externalId", "string"),
        getProp("externalIdType", "string"),

        getProp("height", "number"),
        getProp({
          name: "winTicketPerLike",
          label: "Win Ticket Per Like",
          required: false,
          type: "boolean",
        }),
        {
          required: true,
          type: "number",
          name: "raffleDate",
          label: "Raffle Date",
          options: {
            customBodyRender: (value: number) => {
              if (typeof value === "number") {
                return DateTime.fromMillis(value).toLocaleString(DateTime.DATETIME_FULL)
              }
              return value
            },
          },
        },
        getProp({
          required: false,
          name: "raffleImages",
          type: "array",
          items: {
            type: "string",
          },
          options: {
            customBodyRender: (val: string[]) => {
              return (
                <div className="flex flex-row gap-1">
                  {val?.length
                    ? val.map((image: string, index: number) => (
                        <Avatar key={index} variant="rounded" sizes="sm" src={image} />
                      ))
                    : "[NO RAFFLE MEDIA]"}
                </div>
              )
            },
          },
        }),
        titleLine("Business Info"),
        NAME,
        getProp({ name: "order", type: "number" }),
        getProp({ name: "country", required: false }),

        titleLine("Facil Coins"),
        getProp("value", "number"),
        getProp("points", "number"),
        getProp({
          name: "location",
          default: {
            country: "",
            province: "",
            city: "",
            street: "",
            county: "",
            zipCode: "",
          },
          required: false,
          type: "object",
          properties: {
            country: { type: "string", title: "Country" },
            province: { type: "string", title: "Province" },
            city: { type: "string", title: "City" },
          },

          options: {
            customBodyRender: (value: any) => {
              return (
                <div className="flex flex-col flex-wrap overflow-auto w-40">
                  <p>{JSON.stringify(value)}</p>
                  <button>Edit</button>
                </div>
              )
            },
          },
        }),
        getProp({
          name: "raffleLocation",
          required: false,
          type: "object",
          properties: {
            disabled: { type: "boolean", title: "Disabled" },
            name: { type: "string", title: "Name" },
            country: { type: "string", title: "Country" },
            province: { type: "string", title: "Province" },
            city: { type: "string", title: "City" },
            street: { type: "string", title: "Street" },
            info: { type: "string", title: "Info" },
            phone: { type: "string", title: "Phone" },
            postcode: { type: "string", title: "Postal Code" },
            houseNumber: { type: "string", title: "Location #" },
          },

          options: {
            customBodyRender: (value: any) => {
              return (
                <div className="flex flex-col flex-wrap overflow-auto w-40">
                  <p>{JSON.stringify(value)}</p>
                  <button>Edit</button>
                </div>
              )
            },
          },
        }),

        {
          name: "tickets",
          required: false,
          label: "Tickets",
          hideEdit: true,
          options: {
            customBodyRender: (val: any, e: { rowData: any[] }) => {
              const id = e?.rowData?.[0]
              return <GotoGenerateTicketButton id={id} />
            },
          },
        },
        { hidden: true, name: "value", label: "Value", type: "number" },
        { name: "canDelete", label: "Can Be Deleted", value: true, type: "boolean" },

        { ...ticketDesign(true) },
      ],
      schema: {
        ...raffleSchema,
        properties: {
          ...raffleSchema.properties,
          rafflesImagesLink: { type: "string", title: "Raffles Images Link" },
          allowedZip: {
            type: "string",
            title: "Allowed ZIP Code (5 digits, optional - leave empty for no restriction)",
          },
        },
      },
      uiSchema: {
        ...raffleUISchema,
        allowedZip: {
          ...(raffleUISchema as any)?.allowedZip,
          "ui:emptyValue": "",
          "ui:help": ALLOWED_ZIP_HELP_TEXT,
        },
      },
      ObjectFieldTemplate: CustomObjectFieldTabs,
      prepareFormData: normalizeRaffleForForm,
      // fields: {},

      async imageProcessor(
        fromData: {
          raffleImages?: string[]
          raffleMediaItems?: any[]
          goalSettings?: { actionIconAsset?: string }
        },
        handleUpload: (formData: any, handleUpload: any, id: string, mainId?: string) => any,
        id: any,
      ) {
        const normalizedMediaItems = normalizeRaffleMediaItems(fromData.raffleMediaItems)

        if (normalizedMediaItems.length > 0) {
          fromData.raffleMediaItems = await Promise.all(
            normalizedMediaItems.map(async (item: any, index: number) => {
              const nextItem = { ...item }
              const uploadSource =
                typeof item.localDataUrl === "string" && item.localDataUrl.trim()
                  ? item.localDataUrl
                  : item.url

              if (typeof uploadSource === "string") {
                nextItem.url = await handleUpload(id, `raffleMediaItems-${index}`, uploadSource)
              }

              if (typeof item.thumbnailUrl === "string") {
                nextItem.thumbnailUrl = await handleUpload(
                  id,
                  `raffleMediaItems-thumbnail-${index}`,
                  item.thumbnailUrl,
                )
              }

              if (Array.isArray(item.additionalUrls)) {
                nextItem.additionalUrls = await Promise.all(
                  item.additionalUrls.map(async (entry: any, galleryIndex: number) => {
                    if (!entry || typeof entry.url !== "string") {
                      return entry
                    }

                    return {
                      ...entry,
                      url: await handleUpload(
                        id,
                        `raffleMediaItems-gallery-${index}-${galleryIndex}`,
                        entry.url,
                      ),
                    }
                  }),
                )
              }

              delete nextItem.localDataUrl
              return nextItem
            }),
          )
        }

        fromData.raffleMediaItems = stripTemporaryRaffleMediaFields(fromData.raffleMediaItems)
        assertRaffleMediaItemsSafeForPersistence(fromData.raffleMediaItems)

        if (fromData.raffleImages?.length > 0) {
          const imagesURLs = await Promise.all(
            fromData.raffleImages.map((image: string) => {
              /*
                id: any,
                fieldName: any,
                image: string,
                imageInfo: any,
                imagePropName: any,
              */
              return handleUpload(id, this.IMAGES_BUCKET, image)
            }),
          )
          fromData.raffleImages = imagesURLs
        }

        if (fromData.goalSettings?.actionIconAsset) {
          fromData.goalSettings = {
            ...fromData.goalSettings,
            actionIconAsset: await handleUpload(
              id,
              this.IMAGES_BUCKET,
              fromData.goalSettings.actionIconAsset,
            ),
          }
        }

        return prepareRaffleForSave(fromData) || fromData
      },
    })
  }, [availableRaffleTypes])
  if (data === null) {
    return <Loading />
  }





  return (
    <Box>
      <GapStylingComponent
        config={gapStylingConfig} 
        onConfigChange={setGapStylingConfig}
        onSave={saveGapStylingConfig}
      />
      
      <RootComponent 
        config={gapStylingConfig}
        autoLoad={false}
        onConfigLoaded={(config) => setGapStylingConfig(config)}
      >
        <DataProvider {...data}>
          <ListComponent
            format={(formData) =>
              prepareRaffleForSave(formData) || formData
            }
            defaultAddData={{
              type: availableRaffleTypes[0] || "Raffle",
              raffleMode: "standard",
              canDelete: true,
              disabled: false,
              winTicketPerLike: false,
              createdDate: Timestamp.now().toMillis(),
              createdBy: auth.currentUser?.uid || "",
              points: 0,
              value: 0,
              raffleMediaItems: [],
              raffleLocation: {
                disabled: true,
                name: "",
                country: "",
                province: "",
                city: "",
                street: "",
                info: "",
                phone: "",
                postcode: "",
                houseNumber: "",
              },
              location: {
                country: "",
                province: "",
                city: "",
              },
              order: 1,
            }}
          />
        </DataProvider>
      </RootComponent>
    </Box>
  )
}

export default Raffles

function GotoGenerateTicketButton({ id }: { id: string }) {
  const navigate = useNavigate()

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={(e) => {
        e.stopPropagation()
        navigate(`/raffles/${id}/generate-tickets`)
      }}
    >
      Generate Ticket
    </Button>
  )
}
